import axios from "axios";
import qs from "qs";
import store from "@/store/index";

axios.interceptors.request.use(
  config => {
    config.paramsSerializer = params => {
      return qs.stringify(params, {
        arrayFormat: "brackets",
        encode: false
      });
    };

    store.commit("App/setLoading");
    return config;
  },
  error => {
    store.commit("App/clearLoading");
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    store.commit("App/clearLoading");
    return response;
  },
  error => {
    store.commit("App/clearLoading");
    return Promise.reject(error);
  }
);
